import {
    Loader,
    Select,
    Group,
    Text,
} from "@mantine/core";



// import svg from ".././../assets/img/Dexcom.svg"


import { forwardRef, useEffect, useState } from "react";
import { useMedplum } from "@medplum/react";
import { fetchAndFormatPatientList } from "./PatientSelect.service";

interface ItemProps extends React.ComponentPropsWithoutRef<"div"> {
    label: string;
    value: any;
    ehr: string;
    icon: any;
}

interface PatientSelectProps {
    hanldeSelect: any
    onSelectOpen?: (opened: any) => void

  }
export const PatientSelect: React.FC<PatientSelectProps>= ({hanldeSelect, onSelectOpen}) => {

    const medplum = useMedplum();
    const [patientList, setPatientList] = useState<any>([]);
    const [rawPatList, setRawPatList] = useState<any>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [selectedPatient, setSelectedPatient] = useState<any>(null);
    const [patientName, setPatientName] = useState<any>();


    const SelectItem = forwardRef<HTMLDivElement, ItemProps>(
        ({ label, value, ehr, icon, ...others }: ItemProps, ref) => (
            <div ref={ref} {...others}>
                <Group
                    noWrap
                    sx={{
                        justifyContent: "space-between",
                        height: "30px",
                        width: "100%",
                    }}
                >
                    <div>
                        <Text>{label}</Text>
                    </div>
                    <div>{icon}</div>
                </Group>
            </div>
        )
    );

    useEffect(() => {
        getPatientList();
    }, []);

    useEffect(() => {
        hanldeSelect(rawPatList[0]);

    }, [rawPatList]);


    const getPatientList = async () => {

        setIsLoading(true);
        const {FormattedPatientData, patientData} = await fetchAndFormatPatientList(medplum, '_count=500');
        setPatientName(FormattedPatientData[0].label);
        onSelect(FormattedPatientData[0].value);
        setIsLoading(false);
        setRawPatList(patientData);
        setPatientList(FormattedPatientData);   

    };

    const onSelect = (patient: any) => {
        hanldeSelect(rawPatList.find((pat: any) => pat.id === patient));
        setSelectedPatient(patient);
    }

    return (
        <>
            <Select
                // disabled={aiResponse === "Generating..."}
                onDropdownOpen={onSelectOpen? () => onSelectOpen(true) : undefined}
                onDropdownClose={onSelectOpen? () => onSelectOpen(false) : undefined}
                // label="Patient"
                placeholder={isLoading ? "Loading..." : "Search Patient"}
                required={true}
                data={patientList}
                rightSection={isLoading ? <Loader size={"sm"} /> : ""}
                // mt="sm"
                size="lg"
                radius="md"
                value={selectedPatient}
                onChange={onSelect}
                clearable={true}
                sx={{
                  ".mantine-Select-itemsWrapper": {
                    paddingRight: "10px",
                  },
                }}
                searchable
                itemComponent={SelectItem}
            />

        </>
    );
};
